export const PARTNER_TYPES = "/api/pa/Reference/PartnerTypes"
export const PARTNER_TYPE = "/api/pa/Reference/PartnerType/:param"
